import { AutocompleteSuggestionsPluginTranslations } from './types';

export const defaultTranslations: Required<AutocompleteSuggestionsPluginTranslations> =
  {
    fillQueryTitle: (text: string) => `Fill query with "${text}"`,
  };
